module.exports = __webpack_public_path__ + "img/cluster-monitor.589f210a.svg";